import { useEffect, useState } from "react";

// True below Tailwind's md breakpoint (<768px) — i.e. phones / small tablets in portrait.
// Used to switch the services cards from the desktop grid to a horizontal swipe carousel and to
// skip the whileInView fade-in there (off-screen cards in a horizontal scroller never enter the
// viewport, so the animation would leave them stuck invisible).
export function useIsMobile(breakpoint = 768) {
  const query = `(max-width: ${breakpoint - 1}px)`;
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== "undefined" && !!window.matchMedia?.(query).matches
  );
  useEffect(() => {
    const mq = window.matchMedia?.(query);
    if (!mq) return;
    const onChange = (e) => setIsMobile(e.matches);
    setIsMobile(mq.matches);
    mq.addEventListener?.("change", onChange);
    return () => mq.removeEventListener?.("change", onChange);
  }, [query]);
  return isMobile;
}
